import { useState } from "react";
import { Popover, Button, Divider, Badge, Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CanDoAction from "../../../../common/services/Permissions/Can";
import { ChangePassword } from "../../../../modals";

export default function LogedIn({ token, isMobile, openConfirmModal }) {
  const { isAuthenticated, user } = useSelector((state) => state?.auth);
  const navigate = useNavigate();
  const [isPopOverOpened, setIsPopOverOpened] = useState(false);
  const [change_password_opened, setChange_Password_opened] = useState(false);

  return (
    <div
      className="register-cont__btnsWrapper"
      style={{
        marginRight: "6px",
      }}>
      <Popover
        placement="bottomLeft"
        trigger="click"
        open={isPopOverOpened}
        onOpenChange={() => {
          setIsPopOverOpened(!isPopOverOpened);
        }}
        content={
          <div className="register-cont__btnsWrapper__popOverContent">
            <Button
              type="text"
              className="register-cont__btnsWrapper__popOverContent__btn"
              onClick={() => {
                setIsPopOverOpened(false);
                navigate("/profile");
              }}>
              {user?.is_organization
                ? user?.name || ""
                : `${user?.first_name ? user?.first_name : ""} ${
                    user?.last_name ? user?.last_name : ""
                  }`}
            </Button>
            <Divider
              type="horizontal"
              style={{
                marginTop: "0px",
                marginBottom: "0px",
                width: "100%",
              }}
            />
            <CanDoAction
              isOrganization={user?.is_organization && isAuthenticated}>
              <Button
                type="text"
                className="register-cont__btnsWrapper__popOverContent__btn"
                onClick={() => {
                  setIsPopOverOpened(false);
                  setChange_Password_opened(true);
                }}>
                Change Password
              </Button>
              <Divider
                type="horizontal"
                style={{
                  marginTop: "0px",
                  marginBottom: "0px",
                  width: "100%",
                }}
              />
            </CanDoAction>
            <Button
              danger
              type="text"
              className="register-cont__btnsWrapper__popOverContent__btn"
              onClick={() => {
                setIsPopOverOpened(false);
                openConfirmModal();
              }}>
              Sign Out
            </Button>
          </div>
        }>
        <Badge
          size={isMobile ? "small" : "default"}
          dot
          styles={{
            indicator: {
              background: token?.colorPrimary,
            },
          }}>
          <Avatar
            shape="square"
            style={{
              backgroundColor: token?.Avatar?.colorBgAvatar,
              cursor: "pointer",
            }}
            src={user?.picture_url ? user?.picture_url : ""}
            size={24}
            icon={
              <UserOutlined
                style={{
                  color: `${token?.icons?.whiteIcon}`,
                  fontSize: "18px",
                }}
              />
            }
          />
        </Badge>
      </Popover>
      <ChangePassword
        token={token}
        title={"Change Password"}
        isOpened={change_password_opened}
        onCancel={() => {
          setChange_Password_opened(false);
        }}
      />
    </div>
  );
}
